var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelSms14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "m8.506 5.667.16.002.16.013a2.447 2.447 0 0 1 2.038 3.215 1.4 1.4 0 0 1-.098.259l.23 1.149a.21.21 0 0 1-.205.25h-.013c-.028-.003-.16-.03-1.19-.234a2.4 2.4 0 0 1-1.04.234 2.445 2.445 0 1 1 .118-4.886ZM5.348 3c.904 0 1.71.545 2.096 1.37-2.63-.61-3.8 1.547-2.63 3.455a2.2 2.2 0 0 1-.464-.17l-1.111.23c-.14.029-.263-.1-.235-.247l.22-1.149A2.5 2.5 0 0 1 3 5.444C3 4.097 4.053 3 5.348 3"
}))));
export default SvgChannelSms14;